import { detect } from 'detect-browser'
import memoize from 'memoize-one'

/**
 * Determines if downloads should target an iframe based on browser compatibility.
 *
 * Checks the user's browser against known compatibility issues with frame-targeted
 * downloads. Returns the appropriate target attribute value for download links,
 * or undefined for browsers where frame targeting is not supported.
 *
 * This function is memoized to avoid repeated browser detection calls.
 *
 * @returns 'download-frame' if supported, undefined for unsupported browsers
 */
export const downloadInFrameIfSupported: () =>
  | 'download-frame'
  | null
  | undefined = memoize(() => {
  const browser = detect()
  const browserVersionParts = (browser &&
    browser.version &&
    browser.version.split('.').map(Number)) || [0]

  // target="download-frame" doesn't work on Chrome iOS 12-13 (2019-12-04)
  if (browser && browser.name === 'crios') {
    return undefined
  }
  // target="download-frame" doesn't work on iOS 12
  const firstVersion = browserVersionParts[0]
  if (
    browser &&
    browser.os === 'iOS' &&
    firstVersion !== undefined &&
    firstVersion <= 12
  ) {
    return undefined
  }
  return 'download-frame'
})
